import React, { PropsWithChildren } from 'react';
import classnames from 'classnames';

import { createPortal } from 'react-dom';
import styles from './style/custom-dropdown.module.css';
import useStore from '../../store';

const DropdownModal: React.FC<
  PropsWithChildren<{
    handlePageClick: () => void;
    dropdownRef: React.RefObject<HTMLDivElement>;
  }>> =
({ children, handlePageClick, dropdownRef }) => {
  const headerVisible = useStore((state) => state.visibleHeader);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    document.addEventListener('click', handlePageClick);

    return () => {
      document.removeEventListener('click', handlePageClick);
    };
  }, [handlePageClick]);

  return (
    dropdownRef.current &&
    createPortal(
      <div
        data-testid="custom-dropdown-modal"
        className={styles.dropdownContainer}
        style={{ maxHeight: `calc(100vh - ${headerVisible ? 160 : 100}px)` }}>

				{children}
			</div>,
      dropdownRef.current
    ));

};

const CustomDropdown: React.FC<
  PropsWithChildren<{
    label: string;
    dropdownRef: React.RefObject<HTMLDivElement>;
  }>> =
({ label = 'More', dropdownRef, children }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const closeModal = React.useCallback(() => setIsOpen(false), []);

  if (!children) {
    return null;
  }

  const renderDropdownLinks = () => {
    if (isOpen) {
      return (
        <DropdownModal handlePageClick={closeModal} dropdownRef={dropdownRef}>
					{children}
				</DropdownModal>);

    }

    return (
      <div className={styles.hidden} data-testid="custom-dropdown-ssr-links">
				{children}
			</div>);

  };

  return (
    <>
			<div
        data-testid="custom-dropdown-button"
        data-dropdown-type={label}
        className={styles.dropdownLabel}
        onClick={() => setIsOpen((isOpen) => !isOpen)}>

				{label}
				<span
          className={classnames(
            styles.arrow,
            'iconarrow_rightWhite',
            'iconarrow_rightWhitesize',
            isOpen ? styles.arrowOpen : styles.arrowClose
          )} />

			</div>
			{renderDropdownLinks()}
		</>);

};

export default CustomDropdown;